<template>
    <div id="real_pic_box" class="imageWrapper" ref="imageWrapper">
        <slot v-if="!dataURL"></slot>
    </div>
</template>

<script>
import html2canvas from "html2canvas"
export default {
    data() {
        return {
            dataURL: ''
        }
    },
    methods:{
        createImage(){
            this.$nextTick(()=>{
                this.toImage();
            })
        },
        toImage() {
            // 手动创建一个 canvas 标签
            var shareContent = this.$refs.imageWrapper;
            var width = shareContent.offsetWidth;
            var height = shareContent.offsetHeight;
            var canvas = document.createElement("canvas");
            var scale = 2;
            canvas.width = width * scale;
            canvas.height = height * scale;
            canvas.style.width = width + "px";
            canvas.style.height = height + "px";
            var content = canvas.getContext("2d");
            var rect = shareContent.getBoundingClientRect(); //获取元素相对于视察的偏移量
            content.translate(-rect.left, -rect.top); //设置context位置，值为相对于视窗的偏移量负值，让图片复位
            var opts = {
                scale: scale,
                canvas: canvas,
                logging: true,
                width: width,
                backgroundColor: "#791c17",
                height: height,
                useCORS: true,
            };
            html2canvas(this.$refs.imageWrapper,opts).then((canvas) => {
                let dataURL = canvas.toDataURL("image/png", 1.0);
                this.dataURL = dataURL;
                var imgUri = canvas.toDataURL("image/png"); // 获取生成的图片的url
                var real_pic_box = document.getElementById("real_pic_box");
                var img = new Image();
                img.src = imgUri;
                img.style.width = width+"px";
                real_pic_box.appendChild(img);
            });
        }
    }
}
</script>

<style lang="less" scoped="true">
    #real_pic_box{
        position: absolute;
        left:0;
        top:0;
        width:100%;
        height: 100%;
        font-size:14px;
    }
</style>